import {
    ADD_SEARCHED_USER,
    CHANGE_SEARCH_ITEMS,
    CHANGE_SEARCH_WORD,
    CLEAR_SEARCH_ITEMS,
    GET_TABLE_DATA,
    SUMMARY,
    SHOW_SEARCH_LOADER, 
    HIDE_SEARCH_LOADER,
} from "./types";

const initialState = {
    list: [],
    summary: null,
    searchWord: '',
    searchItems: [],
    searchLoader: null,
    searchedUser: {
        id: null,
        name: null,
        total: null,
        likes: null,
        comments: null,
        messages: null,
    }
}
export const tableReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_TABLE_DATA:
            return {
                ...state,
                list: action.payload,
            }
        case CHANGE_SEARCH_WORD:
            return {
                ...state,
                searchWord: action.payload
            }
        case CHANGE_SEARCH_ITEMS:
            return {
                ...state,
                searchItems: action.payload.searchItems,
            }
        case ADD_SEARCHED_USER:
            return {
                ...state,
                searchedUser: action.payload,
                searchItems: [],
                //searchWord: ''
            }
        case CLEAR_SEARCH_ITEMS:
            return {
                ...state,
                searchItems: action.payload.searchItems,
            }
        case SHOW_SEARCH_LOADER:
            return {
                ...state,
                searchLoader: true
            }
        case HIDE_SEARCH_LOADER:
            return {
                ...state,
                searchLoader: false
            }
        case SUMMARY:
            return {
                ...state,
                summary: action.payload
            }
        default:
            return state
    }
}